<div class="flex w-full flex-col place-items-center gap-2xl md:w-first-touch">
  @if (config().illustrationPath) {
    <img class="w-full" [src]="config().illustrationPath" alt="Module illustration" />
  } @else {
    <ng-content />
  }
  <div class="flex flex-col gap-sm">
    <h5 class="text-center text-base leading-none font-semibold text-subtle">
      {{ config().subtitle | translate }}
    </h5>
    <h4 class="text-center text-4xl leading-none font-bold text-default">
      {{ config().title | translate }}
    </h4>
    <p class="mb-0 text-center text-lg text-support">
      {{ config().description | translate }}
    </p>
  </div>
  <button
    sb-button
    [color]="'primary'"
    [size]="'lg'"
    [disabled]="buttonState() !== 'default'"
    (click)="buttonClick.emit()"
  >
    {{ config().buttonLabel | translate }}
  </button>
</div>
